import styled from "styled-components";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { FlexRowDiv, FlexColumnDiv } from "../common.styles";
export const GlobalAdminViewParent = styled.div `
    padding: 24px 0;
`;
export const FilterSection = styled.div `
    margin-bottom: 24px;
    padding: 20px;
    background-color: ${colors.black_4};
    border-radius: 8px;
`;
export const FilterRow = styled(FlexRowDiv) `
    gap: 16px;
    align-items: flex-end;
    flex-wrap: wrap;
`;
export const FilterGroup = styled(FlexColumnDiv) `
    gap: 6px;
`;
export const FilterLabel = styled.label `
    font-size: 12px;
    font-weight: 600;
    color: ${colors.black_lighter};
    text-transform: uppercase;
`;
export const DateInput = styled.input `
    padding: 10px 14px;
    border: 1px solid ${colors.black_30};
    border-radius: 6px;
    font-size: ${fontSizes.STANDARD};
    min-width: 150px;

    &:focus {
        outline: none;
        border-color: ${colors.blue_main};
    }
`;
export const PresetButtons = styled(FlexRowDiv) `
    gap: 8px;
    margin-top: 12px;
`;
export const PresetButton = styled.button `
    padding: 6px 12px;
    border: 1px solid ${(props) => (props.active ? colors.blue_main : colors.black_30)};
    border-radius: 4px;
    background-color: ${(props) => (props.active ? colors.blue_5 : "white")};
    color: ${(props) => (props.active ? colors.blue_main : colors.black_main)};
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover:not(:disabled) {
        border-color: ${colors.blue_main};
        background-color: ${colors.blue_5};
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;
export const SummarySection = styled.div `
    margin-bottom: 32px;
`;
export const SummaryHeader = styled(FlexRowDiv) `
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
`;
export const SectionTitle = styled.h2 `
    font-size: ${fontSizes.LARGE};
    font-weight: 600;
    margin: 0;
`;
export const SummaryCardsGrid = styled.div `
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
    margin-bottom: 24px;
`;
export const SummaryCard = styled.div `
    padding: 20px;
    background-color: ${(props) => (props.variant === "primary" ? colors.blue_5 : "white")};
    border: 1px solid ${(props) => (props.variant === "primary" ? colors.blue_main : colors.black_30)};
    border-radius: 8px;
    text-align: center;
`;
export const SummaryValue = styled.div `
    font-size: ${(props) => (props.large ? "36px" : "28px")};
    font-weight: 700;
    color: ${colors.blue_main};
    margin-bottom: 4px;
`;
export const SummaryLabel = styled.div `
    font-size: 12px;
    color: ${colors.black_lighter};
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;
export const ErrorMessage = styled.div `
    background-color: #ffebee;
    color: #c62828;
    padding: 16px 20px;
    border-radius: 8px;
    margin-top: 16px;
`;
export const EmptyState = styled.div `
    text-align: center;
    padding: 60px 40px;
    color: ${colors.black_lighter};
    font-size: 14px;
    background-color: ${colors.black_4};
    border-radius: 8px;
    margin-top: 24px;
`;
export const LoadingOverlay = styled.div `
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 60px;
`;
